import fetcher from '../../modules/ajio-fetch';
import { showLoader, hideLoader } from '../loader';
import { fetchGetJSONResHandler, fetchGetJSONReqOpts } from '../../modules/ajio-fetch/utils';
import { storageAvailable } from '../../components/common/storageAvailable';

function subscribetonewsletterapicall(email, device, os, browser, utmsource) {
  const url = `/api/home/subscribe`;
  return fetcher(
    url,
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: {
        Accept: '*',
        'Content-Type': 'application/json',
        credentials: 'include',
        Cache: 'no-cache'
      },
      credentials: 'include',
      body: JSON.stringify({ email, device, os, browser, utmsource })
    })
  );
}

export function createToken() {
  const url = `/api/home/createToken`;
  return fetcher(
    url,
    fetchGetJSONReqOpts({
      method: 'POST',
      headers: {
        Accept: '*',
        'Content-Type': 'application/x-www-form-urlencoded',
        credentials: 'include',
        Cache: 'no-cache'
      },
      credentials: 'include'
    })
  );
}
function setSubscribeDetails(status) {
  return {
    type: 'SETSUBSCRIBED',
    value: status
  };
}

export function setopenstate() {
  return {
    type: 'SETSUBSCRIBED',
    value: 'open'
  };
}

export function subscribetonewsletter(
  email = '',
  device = '',
  os = '',
  browser = '',
  utmsource = ''
) {
  return function(dispatch) {
    dispatch(showLoader('news-letter'));
    createToken()
      .then(fetchGetJSONResHandler)
      .then(response => subscribetonewsletterapicall(email, device, os, browser, utmsource))
      .then(fetchGetJSONResHandler)
      .then(response => {
        if (response.statusCode === '201') {
          if (storageAvailable('localStorage')) {
            window.localStorage.setItem('newsletterclosed', true);
          }
          dispatch(setSubscribeDetails('subscribed'));
          dispatch(hideLoader('news-letter'));
          setTimeout(function() {
            dispatch(setSubscribeDetails('closed'));
          }, 2000);
        } else {
          dispatch(setSubscribeDetails('mailerror'));
          dispatch(hideLoader('news-letter'));
        }
      })
      .catch(error => {
        dispatch(setSubscribeDetails('error'));
        dispatch(hideLoader('news-letter'));
      });
  };
}
